import {Injectable} from '@angular/core';
import {LoggedUser, Role, ROLES, Ship} from '../model';
import {MyError} from '../constants/error';
import {environment} from 'src/environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Router} from '@angular/router';
import {jwtDecode} from "jwt-decode";
import {ModalErrorComponent} from '../modal/modal-gestioneErrori/modal-error/modal-error.component';
import {MatDialog} from '@angular/material/dialog';
import { getAuth,  OAuthProvider ,  signInWithPopup, Auth } from "firebase/auth";
import { FirebaseApp, initializeApp } from 'firebase/app';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private api_prefix: string;
  private auth: Auth;
  private app: FirebaseApp ;

  constructor(private http: HttpClient,
    private router: Router,
    private dialog: MatDialog) {
    this.api_prefix = environment.backEndUrl;
    // Initialize Firebase
    this.app = initializeApp(environment.firebaseConfig);
    this.auth = getAuth();
  }

  get ships(): Array<Ship> {
    let currentUser: LoggedUser | null = this.getCurrentUser();
    return (currentUser && currentUser.ships) ? currentUser.ships : [];
  }

  get displayName(): string | null {
    let currentUser: LoggedUser | null = this.getCurrentUser();
    return currentUser ? currentUser.displayName : null;
  }
  get username(): string | null {
    let currentUser: LoggedUser | null = this.getCurrentUser();
    return currentUser ? currentUser.email : null;
  }
  get token(): string | null {
    let currentUser: LoggedUser | null = this.getCurrentUser();
    return currentUser ? currentUser.idToken : null;
  }
  get isExpiredToken(): boolean {
    if (this.token) {
      let tokenDecoded: any = jwtDecode(this.token);
      let expMillis = tokenDecoded.exp * 1000;
      let nowMillis = new Date().getTime();
      return nowMillis > expMillis;
    }

    return true;
  }

  getCurrentUser(): LoggedUser | null {
    let currentUserStr = localStorage.getItem('currentUser');
    if (currentUserStr) {
      return JSON.parse(currentUserStr);
    }
    return null;
  }

  getCurrentUserRoles(): ROLES[] {
    let tmp: LoggedUser | null = this.getCurrentUser();
    return tmp ? tmp.user_roles : [];
  }

  public buildCurrentUser(responseLogin: any,idToken: string): LoggedUser | null {
    let user: LoggedUser = new LoggedUser();
    let tokenDecoded: any = jwtDecode(idToken);

    let roles = responseLogin.roles;
    let str_roles: any[] | string = [];

    if (tokenDecoded.name) {
      user.displayName = tokenDecoded.name;
    }
    if (idToken) {
      user.idToken = idToken;
    }
    if (tokenDecoded.email) {
      user.email = tokenDecoded.email;
    }
    if(responseLogin.ships){
      user.ships = responseLogin.ships
    }

    if (roles) {
      str_roles = roles;
      roles = [];
      if (typeof str_roles === "string") {
        let tmp: string = str_roles;
        str_roles = [tmp];
      }

      str_roles.forEach(role => {
        let new_role = Role.get_Role(role);
        if (new_role) roles.push(new_role);
      });

      if (roles) {
        user.user_roles = roles;
      }
    }

    if (user.idToken && user.displayName && user.user_roles) {
      localStorage.setItem('currentUser', JSON.stringify(user));
      return user
    }

    return null
  }

  private retrieveCurrentUser(): LoggedUser | null {
    let user: LoggedUser = new LoggedUser();
    let str_user = localStorage.getItem('currentUser');

    if (str_user) {
      user = JSON.parse(str_user);
    }

    if (user.displayName && user.user_roles) {
      return user;
    }

    return null
  }

  login(token:string) {
    const headers = new HttpHeaders({
      'Authorization':  'Bearer ' + token
    });
    let url = this.api_prefix + "/login";
    return this.http.get(url, { headers });
  }

  // Example -> https://firebase.google.com/docs/auth/web/openid-connect?hl=it#web_6
  signInWithPopupFirebase(){
    let provider= new OAuthProvider(environment.firebaseProvider);
    provider.setCustomParameters({
      prompt: 'login', //force login every time
    });

    return signInWithPopup(this.auth, provider);
  }

  logout(isExpiredToken: boolean = false) {
    localStorage.clear();
    sessionStorage.clear();
    console.log("Signed out!");
    if (isExpiredToken) {
      this.showError();
    } else {
      this.router.navigate(['/']);
    }
  }

  setLoginInfo(responseLogin: any,idToken: string) {
    let user: LoggedUser | null;

    user = this.retrieveCurrentUser();
    if (!user) {
      user = this.buildCurrentUser(responseLogin,idToken);
    }

    if (!user) {
      // Should not happen, however..
      this.logout();
    }
  }

  private showError() {
    const dialogRef = this.dialog.open(ModalErrorComponent, {
      data: {
        customText: 'La sessione è scaduta.',
        customDetails: 'Si prega di rieffettuare il login.'
      } as MyError
    });

    dialogRef.afterClosed().subscribe(() => {
      this.router.navigate(['/']);
    });
  }
}
